import {
  SurveyCaption,
  SurveysResponsesCategoriesQuery,
  SurveysResponsesCategoriesQueryVariables,
} from '@/graphql/generated/graphql';
import { FETCH_SURVEY_RESPONSE_CATEGORIES } from '@/graphql/queries/survey/survey-dashboard';
import { useQuery } from '@apollo/client';
import LikertScale, { Answer } from '../likert-chart';
import { useEffect } from 'react';
import { useSurveyDashboardStore } from '../store/useSurveyDashboard.store';

export default function SurveysResponsesCategories() {
  const {
    selectedSchools,
    currentSurvey,
    updateCaptions,
    updateIsEmpty,
    currentTab,
    selectedComponent,
    page,
    isEmpty,
  } = useSurveyDashboardStore((store) => ({
    isEmpty: store.isEmpty,
    selectedSchools: store.selectedSchoolsIds,
    currentSurvey: store.currentSurvey,
    currentTab: store.currentTab,
    selectedComponent: store.selectedComponent,
    page: store.page,
    updateCaptions: store.updateCaptions,
    updateIsEmpty: store.updateIsEmpty,
  }));

  const { data, loading } = useQuery<SurveysResponsesCategoriesQuery, SurveysResponsesCategoriesQueryVariables>(
    FETCH_SURVEY_RESPONSE_CATEGORIES,
    {
      variables: {
        surveyId: currentSurvey?.id ? Number(currentSurvey.id) : 0,
        schoolIds: selectedSchools.length ? selectedSchools.map(Number) : null,
      },
    },
  );

  useEffect(() => {
    if (currentTab === 'survey-responses' && selectedComponent === page?.toggle.categories) {
      console.log({ data });
      updateIsEmpty(data?.surveysResponsesCategories?.data?.length === 0 || !data);
      updateCaptions(data?.surveysResponsesCategories?.captions as SurveyCaption[]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, currentTab, selectedComponent, page?.toggle.categories]);

  const questions = data?.surveysResponsesCategories?.data || [];

  if (isEmpty && !loading) {
    return (
      <div className=" col-span-12 text-center">
        <h1 className=" !text-sh-md !font-bold">{page?.notFoundMessage}</h1>
      </div>
    );
  }

  return (
    <div className="col-span-12 overflow-x-auto overflow-y-hidden pb-5">
      <div className="min-w-[1000px] divide-y">
        <table className="min-w-full">
          <colgroup>
            <col className="w-3/12" />
            <col className="w-1/12" />
            <col className="w-1/12" />
            <col className="w-7/12" />
          </colgroup>
          <thead>
            <tr className="text-sh-xxxs font-bold text-black-100">
              <th className="px-1 py-2" scope="col">
                {page?.tableCategories.questionCategory}
              </th>
              <th className="px-1 py-2" scope="col">
                {page?.tableCategories.responses}
              </th>
              <th className="px-1 py-2" scope="col">
                {page?.tableCategories.questions}
              </th>
              <th className="px-1 py-2" scope="col">
                {page?.tableCategories.answers}
              </th>
            </tr>
          </thead>
          <tbody className="text-sh-xxxs font-bold text-black-100">
            {loading || !questions
              ? // Render 3 skeleton rows during loading
                Array.from({ length: 4 }).map((_, index) => (
                  <tr key={`skeleton-${index}`} className="animate-pulse">
                    <td className="px-1 py-2 text-center">
                      <div className="h-4 rounded bg-gray-300"></div>
                    </td>
                    <td className="px-1 py-2 text-center">
                      <div className="h-4 rounded bg-gray-300"></div>
                    </td>
                    <td className="px-1 py-2 text-center">
                      <div className="h-4 rounded bg-gray-300"></div>
                    </td>
                    <td className="px-1 py-2 text-center">
                      <div className="h-4 rounded bg-gray-300"></div>
                    </td>
                  </tr>
                ))
              : questions.map((question, i) => {
                  return (
                    <tr key={i} className="border-b border-[#89B4FD80] last:border-b-0">
                      <td className="px-1 py-2 text-center">{question?.measure}</td>
                      <td className="px-1 py-2 text-center">{question?.responses}</td>
                      <td className="px-1 py-2 text-center">{question?.questions}</td>
                      <td className="px-1 py-2 text-center">
                        <LikertScale answers={question?.answers as Answer[]} />
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
